// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as CardSeparator from "./CardSeparator.bs.js";
import * as RecordsWrapper from "./RecordsWrapper.bs.js";
import * as CardTitleWithImage from "./CardTitleWithImage.bs.js";
import * as PrimaryCard$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/custom/primary-card/PrimaryCard.bs.js";
import * as CardComponent$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/custom/cards/CardComponent.bs.js";
import * as CardRowViewMapper$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/custom/cards/CardRowViewMapper.bs.js";
import * as NLOrderMiscellaneousInfoVm from "./vm-mapper/NLOrderMiscellaneousInfoVm.bs.js";
import * as OrderDashboardAssetsManager from "../../../assets/OrderDashboardAssetsManager.bs.js";

var other_icon = OrderDashboardAssetsManager.getImage("others.svg");

function getViewLabel(rating_info) {
  return {
          hd: {
            label: "Customer Rating",
            value: {
              TAG: /* Text */0,
              _0: rating_info.customer_rating
            }
          },
          tl: /* [] */0
        };
}

function NLOrderMiscellaneousInfo$RatingInfo(Props) {
  var rating = Props.rating;
  return React.createElement(CardComponent$Catalyst.make, {
              title: "Rating Information",
              className: "info-card",
              children: React.createElement(RecordsWrapper.make, {
                    children: CardRowViewMapper$Catalyst.CardRecordView.make("record", getViewLabel(rating))
                  })
            });
}

var RatingInfo = {
  getViewLabel: getViewLabel,
  make: NLOrderMiscellaneousInfo$RatingInfo
};

function getViewLabel$1(other_info) {
  return {
          hd: {
            label: "Is Penalty Applied",
            value: {
              TAG: /* Text */0,
              _0: other_info.is_penalty_applied
            }
          },
          tl: {
            hd: {
              label: "Order Source",
              value: {
                TAG: /* Text */0,
                _0: other_info.order_source
              }
            },
            tl: {
              hd: {
                label: "Booking Type",
                value: {
                  TAG: /* Text */0,
                  _0: other_info.booking_type
                }
              },
              tl: /* [] */0
            }
          }
        };
}

function NLOrderMiscellaneousInfo$OtherInfo(Props) {
  var other = Props.other;
  return React.createElement("div", undefined, React.createElement(CardComponent$Catalyst.make, {
                  title: "Other Information",
                  className: "info-card",
                  children: React.createElement(RecordsWrapper.make, {
                        children: CardRowViewMapper$Catalyst.CardRecordView.make("record", getViewLabel$1(other))
                      })
                }));
}

var OtherInfo = {
  getViewLabel: getViewLabel$1,
  make: NLOrderMiscellaneousInfo$OtherInfo
};

function NLOrderMiscellaneousInfo(Props) {
  var order = Props.order;
  var match = NLOrderMiscellaneousInfoVm.getVm(order);
  return React.createElement(PrimaryCard$Catalyst.make, {
              title: {
                TAG: /* Custom */1,
                _0: (function (param) {
                    return React.createElement(CardTitleWithImage.make, {
                                title: "Others",
                                icon_src: other_icon
                              });
                  })
              },
              action: undefined,
              children: null
            }, React.createElement(NLOrderMiscellaneousInfo$RatingInfo, {
                  rating: match.rating
                }), React.createElement(CardSeparator.make, {}), React.createElement(NLOrderMiscellaneousInfo$OtherInfo, {
                  other: match.other
                }));
}

var make = NLOrderMiscellaneousInfo;

export {
  other_icon ,
  RatingInfo ,
  OtherInfo ,
  make ,
  
}
/* other_icon Not a pure module */
